import React from "react";
import "./styles.css";

import logo_rodape from "../../assets/logo_rodape.png";
import footer1_1 from "../../assets/footer1_1.png";
import footer1_2 from "../../assets/footer1_2.png";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer1">
        <div className="container">
          <figure className="left">
            <img src={logo_rodape} alt="Logo" />
          </figure>

          <div className="right">
            <p className="text">seguimos as normas ABNT E NVISA</p>

            <div className="imgs">
              <figure className="img1">
                <img src={footer1_1} alt="ABNT" />
              </figure>

              <figure className="img2">
                <img src={footer1_2} alt="ANVISA" />
              </figure>
            </div>
          </div>
        </div>
      </div>

      <div className="footer2">
        <div className="container">
          <p className="text">
            <b>Telefone:</b> (21) 96459-8639
          </p>

          <p className="text">© Copyright 2009-2024, TPC - TUDO PARA COIFAS</p>

          <p className="text2">
            Desenvolvido por{" "}
            <a href="https://magencia.com.br" target="_blank" rel="noreferrer">
              M Agência Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
